import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-quill/dist/quill.snow.css'
import { Redirect } from 'react-router-dom';
import { Tooltip } from 'bootstrap';

import { getTokenInfo } from '../../UseToken';
import { api_crud_base, api_crud_route, api_list_route, data_interface, endpoints } from './Config';
import UseSidebar from '../../UseSidebar';
import 'react-phone-number-input/style.css'
import Hosts, { companycode } from '../../Hosts';

import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    translate,
    check_interface,

} from '../../Utils';

import Swal from 'sweetalert2'
import { language } from './Language';
import { color } from "../WEBContent/Color";
import { set } from 'core-js/core/dict';

export default function View(props) {

    const dados = useRef(null);
    const [, set_dados] = useState(null);
    const [isRedirect, setRedirect] = useState(false);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');

    const [is_edit, set_is_edit] = useState(false)
    const [, set_image_base64] = useState([])
    const [show_delete_button, set_show_delete_button] = useState(false)

    const [refresh, setRefresh] = useState(0);
    const event_type = useRef(null);
    const entidades = useRef(null);

    const [files_image, set_files_image] = useState([])
    const [img_loader, set_img_loader] = useState([])

    const [name, setName] = useState(null)
    const [profile, setProfile] = useState(null)
    const [userID, setUserId] = useState(null)

    //Sondagens
    const [options, setOptions] = useState([]);
    const [newOption, setNewOption] = useState("");
    const [votes, setVotes] = useState({});
    const [userVotes, setUserVotes] = useState({});

    const [data, setData] = useState([]);
    const permissions = useRef(null);
    const { pathname } = useLocation()
    const [document_state_list, set_document_state_list] = useState([])

    const get_info = async () => {
        //await reqGET(api_list_route(getTokenInfo().companycode))
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }

    function apagar() {
        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: dados.current.id })
                        .then(() => {
                            props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
            .catch((erro) => {
                console.log(erro)
            })

    };

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    const savePoll = async () => {
        try {
            let res;

            if (dados.current?.id) {
                res = await reqPUT(`${api_crud_route}`, dados.current);
                return res?.data?.id || res?.data?._id || dados.current.id;

            } else {
                res = await reqPOST(`${api_crud_route}`, dados.current);
                return res?.data?.id || res?.data?._id;
            }

        } catch (err) {
            console.error("Error saving evento:", err);
        }
    };

    // ➡️ Adicionar opção
    const handle_add_option = async () => {
        if (newOption.trim() === "") return;

        const result = await Swal.fire({
            title: language[lang].adicionar_opcao,
            text: `${language[lang].confirmar_opcao} "${newOption}"?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: language[lang].insert_confirm,
            cancelButtonText: language[lang].insert_cancel,
        });

        if (!result.isConfirmed) return;

        const id = Date.now().toString();
        const newOpt = { id, text: newOption };

        const updatedOptions = [...options, newOpt];

        setOptions(updatedOptions);
        setNewOption("");

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes,
        };

        if (parseInt(dados.current.info.votacao) === 1) {
            Object.keys(votes).forEach((key) => {
                if (!updatedOptions.find((o) => o.id === key)) {
                    delete votes[key];
                }
            });
        }

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].adicionada, language[lang].adicionada_placeholder, "success");
    };

    const handle_remove_option = async (id) => {
        const optionToRemove = options.find((o) => o.id === id);
        if (!optionToRemove) return;

        const result = await Swal.fire({
            title: language[lang].remover_opcao,
            text: `${language[lang].remover_opcao_placeholder} "${optionToRemove.text}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel,
        });

        if (!result.isConfirmed) return;

        const updatedOptions = options.filter((o) => o.id !== id);

        const updatedVotes = { ...votes };
        delete updatedVotes[id];

        setOptions(updatedOptions);
        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes: updatedVotes,
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].removida, language[lang].removida_placeholder, "success");
    };

    // ➡️ Votar
    const handle_vote = async (id) => {
        let updatedVotes = { ...votes };
        let updatedVoters = new Set(dados.current.info.poll?.voters || []);

        if (dados.current.info.votacao_oculta === "2") {
            if (updatedVoters.has(userID)) {
                await Swal.fire(language.erro, language.insert_error, "error");
                return;
            }

            const result = await Swal.fire({
                title: language[lang].confirmar_voto,
                text: language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(dados.current.info.votacao) === 1) {
                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = 0;
                });
            }

            updatedVotes[id] = (updatedVotes[id] || 0) + 1;
            updatedVoters.add(userID);
        }

        else {
            const alreadyVoted = updatedVotes[id]?.some((u) => u.userID === userID);

            const result = await Swal.fire({
                title: alreadyVoted ? language[lang].remover_voto : language[lang].confirmar_voto,
                text: alreadyVoted
                    ? language[lang].remover_voto_placeholder
                    : language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(dados.current.info.votacao) === 1) {

                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = (updatedVotes[key] || []).filter(
                        (u) => u.userID !== userID
                    );
                });
            }

            if (alreadyVoted) {
                updatedVotes[id] = updatedVotes[id].filter((u) => u.userID !== userID);

            } else {
                updatedVotes[id] = [
                    ...(updatedVotes[id] || []),
                    { userID, name, profile },
                ];
            }
        }

        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options,
            votes: updatedVotes,
            voters: Array.from(updatedVoters),
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].sucesso, language[lang].escolha, "success");
    };

    // ➡️ Remover voto
    const handle_unvote = async (id) => {
        let updatedVotes = { ...votes };
        let updatedVoters = new Set(dados.current.info.poll?.voters || []);

        if (dados.current.info.votacao_oculta === "2") {
            if (!updatedVoters.has(userID)) {
                Swal.fire("Erro", "Ainda não votaste, não há nada para remover.", "error");
                return;
            }
        }

        const result = await Swal.fire({
            title: "Remover voto?",
            text: "Queres mesmo remover o teu voto?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
        });

        if (!result.isConfirmed) return;

        if (dados.current.info.votacao_oculta === "2") {
            // Apenas decrementa e remove do array de votantes
            if (updatedVotes[id] > 0) {
                updatedVotes[id] = updatedVotes[id] - 1;
            }
            updatedVoters.delete(userID);
        } else {
            // Votação não oculta → pode remover o voto sempre que quiser
            updatedVotes[id] = updatedVotes[id]?.filter((u) => u.userID !== userID) || [];
        }

        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options,
            votes: updatedVotes,
            voters: Array.from(updatedVoters),
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire("Voto removido!", "O teu voto foi retirado.", "success");
    };

    // ➡️ Cálculo total de votos
    const totalVotes = Object.values(votes).reduce((acc, val) => {
        if (Array.isArray(val)) return acc + val.length;
        if (typeof val === "number") return acc + val;
        return acc;
    }, 0);

    useEffect(() => {
        if (dados.current?.info?.poll) {
            const {
                options: savedOptions = [],
                votes: savedVotes = {},
                voters: savedVoters = [],
            } = dados.current.info.poll;

            setOptions(savedOptions);
            setVotes(savedVotes);
            setUserVotes(savedVoters);
        }

        if (!dados.current?.info) return;

        const checkDeadline = async () => {
            const deadlineDate = dados.current.info.poll.poll_deadline_date;
            const deadlineTime = dados.current.info.poll.poll_deadline_time;

            if (deadlineDate && deadlineTime) {
                const [year, month, day] = deadlineDate.split('-').map(Number);
                const [hours, minutes] = deadlineTime.split(':').map(Number);

                const deadline = new Date(year, month - 1, day, hours, minutes);
                const now = new Date();

                console.log("Now:", now, "Deadline:", deadline);

                if (now >= deadline && !dados.current.info.isLocked) {
                    dados.current.info.isLocked = true;
                    set_dados({ ...dados.current });

                    // 🔥 Persist change in backend
                    try {
                        await reqPUT(`${api_crud_route}`, dados.current);
                    } catch (err) {
                        console.error("Failed to update isLocked:", err);
                    }

                    return true;
                }
            }
            return false;
        };

        // run once immediately
        checkDeadline();

        const interval = setInterval(() => {
            checkDeadline().then((locked) => {
                if (locked) clearInterval(interval);
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [dados.current]);

    const fetch_id_info = async (id_serch) => {

        return await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
            .then(res => {

                set_dados(dados.current = res.data[0]);

            })
            .catch(error => console.log(error))
    }

    const clean_data = () => {
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
    }

    useEffect(() => {


        console.log('props.location.state', props.location.state)


        clean_data();

        get_type_event()
        fetch_entidades()

        set_lang(localStorage.getItem('lang'))

        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);

        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }

        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }

        try {
            let test = props.location.state.operation;

            if (test === 'view') {
                //set_disabled(true)

                set_is_edit(true)
                set_show_delete_button(true)

                set_image_base64([])
                set_dados(dados.current.id = props.location.state.item.id)


                fetch_id_info(props.location.state.item.id).then(() => {
                    setLoading(false)
                    //setRefresh(refresh + 1)
                })
                return
            }
            else {
                set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
                setLoading(false)
            }

        } catch {
            clean_data()

            setLoading(false);

            setRedirect(false);
            return
        }

        return () => {
            clean_data()

        }

    }, [props])

    const get_type_event = async () => {
        let res_event = await reqGET(`${api_crud_base}/evento/type/${getTokenInfo().companycode}/event_type`);
        let result = [];

        if (res_event.data !== undefined) {
            result = res_event.data.filter(el => el.info.avaiable === true);
        }

        set_dados(event_type.current = result);
    };

    const fetch_entidades = async () => {
        try {
            let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
            let result = [];

            if (res_entidade.data !== undefined) {
                result = res_entidade.data.filter(el => el.entity_type === "1");
            }

            set_dados(entidades.current = result);

        } catch (error) {
            console.error("Erro ao buscar as Entidades:", error);
            return [];
        }
    };

    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        [...tooltipTriggerList].map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
    }, [options, votes]);

    return isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language[lang].loading}</h2>
                <p>{language[lang].loading}</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>
            </div>
        </main>
        :
        isRedirect
            ?
            <Redirect to={endpoints.list} replace />
            :
            <main>
                <div className="dash-cards-2 header">
                    <div className="row mt-4 mb-3">
                        <div className="container my-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 col-lg-7">
                                    <div className="card border-0 shadow-lg">
                                        <div className="card-body text-center p-4">
                                            <h3 className="fw-semibold mb-3 text-dark">
                                                {dados.current.info?.event_type?.name || ""} {" - "}
                                                {lang === "en"
                                                    ? dados.current.info?.title?.[0]?.en || ""
                                                    : dados.current.info?.title?.[0]?.pt || ""}
                                            </h3>

                                            <p className="text-muted mb-4 lead">
                                                {lang === "en"
                                                    ? dados.current.info?.description?.[0]?.en || ""
                                                    : dados.current.info?.description?.[0]?.pt || ""}
                                            </p>

                                            <div className="d-flex flex-column align-items-center border-top pt-3">
                                                <div className="text-secondary">
                                                    <i className="bi bi-calendar-event me-2"></i>
                                                    <strong>{dados.current.info?.date || ""}</strong> — {dados.current.info?.time || ""}
                                                </div>
                                                <div className="text-secondary mt-2">
                                                    <i className="bi bi-geo-alt-fill me-2"></i>
                                                    <span className="fw-semibold">{dados.current.info?.location || ""}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {dados.current.info?.event_type?.poll_active !== false && (
                            <div className="card border-0 shadow-lg">
                                <div className="container mt-4">
                                    {/* Lista de opções (ordenada por votos) */}
                                    <div className="list-group">
                                        {options
                                            .slice()
                                            .sort((a, b) => {
                                                const votesA = Array.isArray(votes[a.id]) ? votes[a.id].length : 0;
                                                const votesB = Array.isArray(votes[b.id]) ? votes[b.id].length : 0;
                                                return votesB - votesA;
                                            })
                                            .map((o) => {
                                                const votesForOption = votes[o.id] || [];
                                                const userVoted = Array.isArray(votesForOption)
                                                    ? votesForOption.some((u) => u.userID === userID)
                                                    : false;

                                                const optionVotes = Array.isArray(votesForOption)
                                                    ? votesForOption.length
                                                    : votesForOption || 0;

                                                const percent =
                                                    totalVotes > 0 ? Math.round((optionVotes / totalVotes) * 100) : 0;

                                                return (
                                                    <div
                                                        key={o.id}
                                                        className="list-group-item d-flex flex-column mb-3 shadow-sm rounded"
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <div>
                                                                <strong>{o.text}</strong>
                                                                <div
                                                                    className="d-flex mt-1"
                                                                    style={{ position: "relative", maxWidth: "200px" }}
                                                                >
                                                                    {Array.isArray(votesForOption) &&
                                                                        votesForOption.slice(0, 5).map((u, index) => {
                                                                            const entidade = entidades.current?.find(
                                                                                (e) => e.id === u.userID
                                                                            );

                                                                            let fotoUrl = entidade?.foto
                                                                                ? (() => {
                                                                                    try {
                                                                                        const fotos = JSON.parse(entidade.foto);
                                                                                        if (Array.isArray(fotos) && fotos.length > 0)
                                                                                            return fotos[0].link;
                                                                                    } catch (err) {
                                                                                        console.warn(
                                                                                            "Foto JSON inválido:",
                                                                                            entidade.foto
                                                                                        );
                                                                                    }
                                                                                    return null;
                                                                                })()
                                                                                : null;

                                                                            return (
                                                                                <div
                                                                                    key={u.userID}
                                                                                    className="d-flex align-items-center justify-content-center border border-white"
                                                                                    style={{
                                                                                        width: "28px",
                                                                                        height: "28px",
                                                                                        borderRadius: "50%",
                                                                                        overflow: "hidden",
                                                                                        marginLeft: index === 0 ? "0" : "-10px",
                                                                                        backgroundColor: fotoUrl ? "transparent" : "#6c757d",
                                                                                        color: "#fff",
                                                                                        fontWeight: "bold",
                                                                                        fontSize: "12px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    data-bs-toggle="tooltip"
                                                                                    data-bs-placement="top"
                                                                                    title={entidade?.name || "Sem nome"}
                                                                                >
                                                                                    {fotoUrl ? (
                                                                                        <img
                                                                                            src={fotoUrl}
                                                                                            alt={entidade?.name || "user"}
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "100%",
                                                                                                objectFit: "cover",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        entidade?.name
                                                                                            ?.split(" ")
                                                                                            .map((w) => w[0]?.toUpperCase())
                                                                                            .join("")
                                                                                            .substring(0, 2) || "U"
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        })}

                                                                    {votesForOption.length > 5 && (
                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center border border-white"
                                                                            style={{
                                                                                width: "28px",
                                                                                height: "28px",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: "#ddd",
                                                                                fontSize: "12px",
                                                                                fontWeight: "bold",
                                                                                marginLeft: "-10px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title={votesForOption
                                                                                .slice(5)
                                                                                .map((u) => {
                                                                                    const entidade = entidades.current?.find(
                                                                                        (e) => e.id === u.userID
                                                                                    );
                                                                                    return entidade?.name;
                                                                                })
                                                                                .join(", ")}
                                                                        >
                                                                            +{votesForOption.length - 5}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Botões */}
                                                            <div className="btn-group">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handle_vote(o.id)}
                                                                    className="btn btn-sm poll remove text-white"
                                                                    disabled={dados.current.info.isLocked}
                                                                    style={{
                                                                        backgroundColor: userVoted
                                                                            ? color.corNormal.rgb
                                                                            : color.corNaoUrgente.rgb,
                                                                        minWidth: "120px",
                                                                    }}
                                                                >
                                                                    {userVoted ? "Remover voto" : "Votar"}
                                                                </button>

                                                                {dados.current.info?.createadBy?.some(
                                                                    (entry) => entry.userId === userID
                                                                ) && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handle_remove_option(o.id)}
                                                                            className="btn btn-sm text-white"
                                                                            disabled={dados.current.info.isLocked}
                                                                            style={{
                                                                                backgroundColor: color.corCritica.rgb,
                                                                                minWidth: "120px",
                                                                            }}
                                                                        >
                                                                            {language[lang].remove}
                                                                        </button>
                                                                    )}
                                                            </div>
                                                        </div>

                                                        {/* Barra de progresso */}
                                                        <div className="progress" style={{ height: "10px" }}>
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: `${percent}%`,
                                                                    backgroundColor: color.corUrgente.hexa,
                                                                }}
                                                                aria-valuenow={percent}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            />
                                                        </div>
                                                        <small className="text-muted mt-1">
                                                            {optionVotes} {language[lang].votes} ({percent}%)
                                                        </small>
                                                    </div>
                                                );
                                            })}
                                    </div>

                                    {/* Adicionar opção */}
                                    {dados.current.info?.createadBy?.some(
                                        (entry) => entry.userId === userID
                                    ) && (
                                            <div className="input-group mt-4 mb-4">
                                                <input
                                                    type="text"
                                                    value={newOption}
                                                    onChange={(e) => setNewOption(e.target.value)}
                                                    placeholder="Escreve uma nova opção..."
                                                    className="form-control"
                                                    style={{ marginRight: "10px" }}
                                                />

                                                <button
                                                    type="button"
                                                    onClick={handle_add_option}
                                                    className="btn btn-sm poll text-white"
                                                    disabled={dados.current.info.isLocked}
                                                    style={{
                                                        backgroundColor: color.corNaoUrgente.rgb,
                                                        color: "#fff",
                                                        minWidth: "100px",
                                                    }}
                                                >
                                                    {language[lang].add}
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-sm text-white"
                                                    onClick={() => {
                                                        dados.current.info.isLocked = !dados.current.info.isLocked;
                                                        set_dados({ ...dados.current });
                                                    }}
                                                    style={{
                                                        backgroundColor: color.corCritica.rgb,
                                                        minWidth: "120px",
                                                    }}
                                                >
                                                    {dados.current.info.isLocked
                                                        ? language[lang].event_poll_ativar
                                                        : language[lang].event_poll_bloquear}
                                                </button>
                                            </div>
                                        )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">

                                {(dados.current.info?.createadBy?.some((entry) => entry.userId === userID) || permissions.current !== null && permissions.current.create) && (
                                    < li className={"nav-item " + show_delete_button}>
                                        <button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
                                            <i className="bi bi-trash3 me-2"></i>
                                            <span>{language[lang].delete}</span>
                                        </button>
                                    </li>
                                )}

                                {/*
                                    {(permissions.current !== null && permissions.current.create) && (
                                        <Link className="nav-link" to={{ state: { item: { id: eventoId }, operation: 'edit' }, pathname: endpoints.regist }} replace>
                                            <i className={icon.pencil2.className} style={icon.pencil2.style}></i>
                                            <span> {language[lang].edit}</span>
                                        </Link>
                                    )}
                                    */}
                                    
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <i className="bi bi-arrow-left"></i>
                                        <span> {language[lang].back}</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}